import React from "react";
import { User } from "firebase/auth";
import { format } from "date-fns";
import { auth } from "../../firebase-config";

import Loader from "../../components/Loader";
import MediaList from "../../components/MediaList";
import { useHistory } from "../../hooks/HistoryContext";

interface HistoryItem {
    id: string;
    watch_id: number;
    docId: string;
    title: string;
    media_type: string;
    watched_at: string;
    userRating: number | null;
    notes: string | null;
}

const formatDateKey = (watchDate: string): string => {
    if (!watchDate) return "Unknown Date";
    return new Date(watchDate).toISOString().split("T")[0];
};

const History: React.FC = () => {
    const user: User | null = auth.currentUser;
    const { history, historyLoading, historyError } = useHistory();

    if (!user) return <p>Please log in to view your watch history.</p>;
    if (historyLoading) return <Loader size="medium" />;
    if (historyError) return <p>Error loading history: {historyError}</p>;
    if (history.length === 0) return <p>You have no watch history yet.</p>;


    const groupedByDate = history.reduce<Record<string, HistoryItem[]>>((acc, item) => {
        const dateKey = formatDateKey(item.watched_at);
        if (!acc[dateKey]) acc[dateKey] = [];
        acc[dateKey].push(item);
        return acc;
    }, {});

    const sortedDates = Object.keys(groupedByDate).sort((a, b) =>
        a < b ? 1 : -1
    );

    return (
        <div>
            <h2>Your Watch History</h2>
            {
                sortedDates.map((date) => (
                    <div key={date} style={{ marginBottom: "2rem" }}>
                        <h3>{format(date, 'd MMMM yyyy')}</h3>
                        <MediaList media={groupedByDate[date]} />
                    </div>
                ))
            }
        </div>
    );
};

export default History;
